import clsx from 'clsx';
import { baseButtonClass } from '../index';
import { Triangle } from './Triangle';
import { Circle } from './Circle';
import { KeyboardBackspace } from '@material-ui/icons';
import { RemoteButton } from '../../../../hooks/useRemote';

interface Props {
  buttons: RemoteButton[];
  onClick(commandId: number): void;
}

export const NavigationPad = ({ buttons, onClick }: Props) => {
  const classes = useStyles();

  const getButton = (position: number) =>
    buttons.find((button) => button.order === position);

  const handlePress = (position: number) => {
    const button = getButton(position);
    if (button === undefined) return undefined;
    return onClick(button.id);
  };

  return (
    <div className="relative col-span-full h-fit">
      <div
        className={clsx('relative grid grid-cols-3 grid-rows-3', {
          'gap-2': window.devicePixelRatio > 1,
          'gap-4': window.devicePixelRatio <= 1,
        })}
      >
        <Circle
          disabled={Boolean(getButton(1)) === false}
          label="BACK"
          className="mt-auto mx-auto"
          onClick={() => handlePress(1)}
          onTouchEnd={() => handlePress(1)}
          size="md"
        >
          <KeyboardBackspace fontSize="small" />
        </Circle>
        <Triangle
          disabled={Boolean(getButton(2)) === false}
          direction="up"
          onClick={() => handlePress(2)}
          onTouchEnd={() => handlePress(2)}
        />
        <Circle
          disabled={Boolean(getButton(3)) === false}
          label="GO INTER."
          className="mt-auto mx-auto"
          onClick={() => handlePress(3)}
          onTouchStart={() => handlePress(3)}
          onTouchEnd={() => handlePress(3)}
          size="md"
        />
        <Triangle
          disabled={Boolean(getButton(4)) === false}
          direction="left"
          onClick={() => handlePress(4)}
          onTouchEnd={() => handlePress(4)}
        />
        <button
          disabled={Boolean(getButton(5)) === false}
          className={clsx(
            baseButtonClass,
            'rounded-full w-12 h-12 m-auto !text-xl font-normal',
            { 'scale-75': window.devicePixelRatio > 1 }
          )}
          onClick={() => handlePress(5)}
          onTouchEnd={() => handlePress(5)}
        >
          OK
        </button>
        <Triangle
          disabled={Boolean(getButton(6)) === false}
          direction="right"
          onClick={() => handlePress(6)}
          onTouchEnd={() => handlePress(6)}
        />
        <Circle
          disabled={Boolean(getButton(7)) === false}
          label="EXIT TO"
          className="mx-auto mb-auto children:text-[0.55rem] children:tracking-wider"
          onClick={() => handlePress(7)}
          onTouchEnd={() => handlePress(7)}
          size="md"
        >
          TV
        </Circle>
        <Triangle
          disabled={Boolean(getButton(8)) === false}
          direction="down"
          onClick={() => handlePress(8)}
          onTouchEnd={() => handlePress(8)}
        />
        <Circle
          disabled={Boolean(getButton(9)) === false}
          label="INFO"
          className="mx-auto mb-auto"
          onClick={() => handlePress(9)}
          onTouchEnd={() => handlePress(9)}
          size="md"
        />
      </div>
    </div>
  );
};

const useStyles = () => ({
  row: 'w-full inline-flex items-center justify-between',
});
